import type { ReactNode } from 'react';

import type { GiftPassDetail } from '../../api/gift-passes';

import { formatPassDate } from './gift-passes-model';
import { GiftPassCodeReveal } from './GiftPassCodeReveal';
import { GiftPassOriginFields } from './GiftPassOriginFields';
import { GiftPassOutcomeFields } from './GiftPassOutcomeFields';
import { GiftPassPartyBlock } from './GiftPassPartyBlock';
import { GiftPassStatusPill } from './GiftPassStatusPill';

export interface GiftPassSummaryCardProps {
  pass: GiftPassDetail;
  actions?: ReactNode;
}

export function GiftPassSummaryCard({ pass, actions }: GiftPassSummaryCardProps) {
  return (
    <section
      className="nb-card"
      aria-label="Gift pass details"
      style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <GiftPassCodeReveal code={pass.code} codeMasked={pass.codeMasked} />
          <div style={{ fontSize: 11.5, color: 'var(--nb-subtle)', marginTop: 3 }}>
            Created {formatPassDate(pass.createdAt)} · Good for one workshop seat
          </div>
        </div>
        <GiftPassStatusPill status={pass.status} />
      </div>

      <div className="gp-party-grid gp-section">
        <GiftPassPartyBlock
          caption="Purchaser"
          name={pass.purchaser.name}
          email={pass.purchaser.email}
          emptyText="No purchaser recorded."
        />
        <GiftPassPartyBlock
          caption="Recipient"
          name={null}
          email={pass.recipientEmail}
          emptyText="Not sent to anyone. Whoever holds the code can use it."
        />
      </div>

      <GiftPassOriginFields pass={pass} />
      <GiftPassOutcomeFields pass={pass} />

      {actions && (
        <div
          className="gp-section"
          style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}
        >
          {actions}
        </div>
      )}
    </section>
  );
}
